module.exports = __webpack_public_path__ + "assets/travel_black.00a5c9dc.svg";